var U = /* @__PURE__ */ ((E) => (E.CODE = "CODE", E.PDF = "PDF", E.IMAGE = "IMAGE", E.CSV = "CSV", E.ARCHIVE = "ARCHIVE", E.FOLDER = "FOLDER", E.UNKNOWN = "UNKNOWN", E))(U || {}), L = /* @__PURE__ */ ((E) => (E.NOT_COLLECTED = "NOT_COLLECTED", E.NOT_CONNECTED = "NOT_CONNECTED", E.RED = "RED", E.AMBER = "AMBER", E.GREEN = "GREEN", E))(L || {}), c = /* @__PURE__ */ ((E) => (E.INITIAL = "INITIAL", E.AWAITING_APPROVAL = "AWAITING_APPROVAL", E.PENDING = "PENDING", E.QUEUED = "QUEUED", E.PREPARING = "PREPARING", E.IN_PROGRESS = "IN_PROGRESS", E.AWAITING_PUBLISHING_APPROVAL = "AWAITING_PUBLISHING_APPROVAL", E.PUBLISHED = "PUBLISHED", E.FAILED = "FAILED", E.DISMISSED = "DISMISSED", E.PROCESSING_RESULTS = "PROCESSING_RESULTS", E.PROCESSING_RESULTS_FAILED = "PROCESSING_RESULTS_FAILED", E.CANCELING = "CANCELING", E.CANCELLED = "CANCELLED", E))(c || {}), Y = /* @__PURE__ */ ((E) => (E.LEAD_INVESTIGATOR = "LEAD_INVESTIGATOR", E.CONTRIBUTOR = "CONTRIBUTOR", E.DATA_SET_OWNER = "DATA_SET_OWNER", E))(Y || {}), a = /* @__PURE__ */ ((E) => (E.DEFAULT = "Default", E.CONCEPT_SET = "ConceptSet", E.INCOMPLETE_RULE = "IncompleteRule", E))(a || {}), G = /* @__PURE__ */ ((E) => (E.INFO = "INFO", E.WARNING = "WARNING", E.CRITICAL = "CRITICAL", E.DEFAULT = "DEFAULT", E))(G || {}), M = /* @__PURE__ */ ((E) => (E.STRING = "STRING", E.INTEGER = "INTEGER", E.ENUM = "ENUM", E.ENUM_MULTI = "ENUM_MULTI", E))(M || {}), H = /* @__PURE__ */ ((E) => (E.SUPERVISED = "SUPERVISED", E.UNSUPERVISED = "UNSUPERVISED", E.MANUAL = "MANUAL", E))(H || {}), V = /* @__PURE__ */ ((E) => (E.DASHBOARD = "dashboard", E.DATA_DENSITY = "datadensity", E.PERSON = "person", E.VISITS = "visits", E.CONDITIONS = "conditions", E.CONDITION_ERAS = "conditionera", E.PROCEDURES = "procedures", E.DRUG_EXPOSURES = "drugexposures", E.DRUG_ERAS = "drugeras", E.MEASUREMENT = "measurement", E.OBSERVATIONS = "observations", E.OBSERVATION_PERIODS = "observationperiods", E.DEATH = "death", E.ACHILLES_HEEL = "achillesheel", E.COST = "cost", E))(V || {}), S = /* @__PURE__ */ ((E) => (E.INITIATE = "INITIATE", E.ACTIVE = "ACTIVE", E.COMPLETED = "COMPLETED", E.ARCHIVED = "ARCHIVED", E))(S || {}), R = /* @__PURE__ */ ((E) => (E.REJECTED = "REJECTED", E.DISABLED = "DISABLED", E.ACTIVE = "ACTIVE", E.PENDING = "PENDING", E.CANCELLED = "CANCELLED", E.ACCEPTED = "ACCEPTED", E))(R || {}), m = /* @__PURE__ */ ((E) => (E.DEV = "development", E.PROD = "production", E.TEST = "test", E.STAGE = "stage", E))(m || {}), A = /* @__PURE__ */ ((E) => (E.STUDY = "STUDY", E.WORKSPACE = "WORKSPACE", E.LIBRARY = "LIBRARY", E.DETACHED = "DETACHED", E))(A || {}), N = /* @__PURE__ */ ((E) => (E.INTEGER = "INTEGER", E.ENUM_MULTI = "ENUM_MULTI", E.ENUM = "ENUM", E.STRING = "STRING", E))(N || {}), C = /* @__PURE__ */ ((E) => (E.COHORT = "COHORT", E.COHORT_CHARACTERIZATION = "COHORT_CHARACTERIZATION", E.COHORT_PATHWAY = "PATHWAY", E.FEASIBILITY = "FEASIBILITY", E.ESTIMATION = "ESTIMATION", E.PREDICTION = "PREDICTION", E.INCIDENCE = "INCIDENCE_RATE", E.CUSTOM = "CUSTOM", E.STRATEGUS = "STRATEGUS", E.SIMPLE_COUNTS_CHARACTERIZATION = "SIMPLE_COUNTS_CHARACTERIZATION", E.DATACUT = "DATACUT", E.BULK_COHORT_COUNTS = "BULK_COHORT_COUNTS", E.PATHWAY = "PATHWAY", E.INCIDENCE_RATE = "INCIDENCE_RATE", E.TIME_TO_EVENT = "TIME_TO_EVENT", E.COST = "COST", E))(C || {}), v = /* @__PURE__ */ ((E) => (E.CONDITION_ERA = "ConditionEra", E.CONDITION_OCCURRENCE = "ConditionOccurrence", E.DEATH = "Death", E.DEVICE_EXPOSURE = "DeviceExposure", E.DOSE_ERA = "DoseEra", E.DRUG_ERA = "DrugEra", E.DRUG_EXPOSURE = "DrugExposure", E.MEASUREMENT = "Measurement", E.OBSERVATION = "Observation", E.OBSERVATION_PERIOD = "ObservationPeriod", E.PAYER_PLAN_PERIOD = "PayerPlanPeriod", E.PROCEDURE_OCCURRENCE = "ProcedureOccurrence", E.SPECIMEN = "Specimen", E.VISIT = "VisitOccurrence", E.VISIT_DETAILS = "VisitDetail", E.DEMOGRAPHIC = "Demographic", E.GROUP = "Group", E.LOCATION_REGION = "LocationRegion", E))(v || {}), B = /* @__PURE__ */ ((E) => (E.FIRST = "First", E.AGE = "Age", E.AGE_START = "AgeAtStart", E.AGE_END = "AgeAtEnd", E.GENDER = "Gender", E.ERA_START_DATE = "EraStartDate", E.ERA_END_DATE = "EraEndDate", E.START_DATE = "StartDate", E.END_DATE = "EndDate", E.OCCURRENCE_COUNT = "OccurrenceCount", E.ERA_LENGTH = "EraLength", E.CORRETALED_CRITERIA = "CorrelatedCriteria", E.OCCURRENCE_START_DATE = "OccurrenceStartDate", E.OCCURRENCE_END_DATE = "OccurrenceEndDate", E.CONDITION_TYPE = "ConditionType", E.CONDITION_TYPE_CS = "ConditionTypeCS", E.CONDITION_TYPE_EXCLUDE = "ConditionTypeExclude", E.STOP_REASON = "StopReason", E.CONDITION_STATUS = "ConditionStatus", E.CONDITION_STATUS_CS = "ConditionStatusCS", E.VISIT_TYPE = "VisitType", E.VISIT_TYPE_CS = "VisitTypeCS", E.PROVIDER_SPECIALTY = "ProviderSpecialty", E.CONDITION_SOURCE_CONCEPT = "ConditionSourceConcept", E.DEATH_SOURCE_CONCEPT = "DeathSourceConcept", E.DEATH_TYPE = "DeathType", E.DEATH_TYPE_CS = "DeathTypeCS", E.DEATH_TYPE_EXCLUDE = "DeathTypeExclude", E.UNIQUE_DEVICE_ID = "UniqueDeviceId", E.QUANTITY = "Quantity", E.DEVICE_TYPE = "DeviceType", E.DEVICE_TYPE_CS = "DeviceTypeCS", E.DEVICE_TYPE_EXCLUDE = "DeviceTypeExclude", E.DEVICE_SOURCE_CONCEPT = "DeviceSourceConcept", E.UNIT = "Unit", E.UNIT_CS = "UnitCS", E.DOSE_VALUE = "DoseValue", E.DRUG_TYPE = "DrugType", E.DRUG_TYPE_CS = "DrugTypeCS", E.DRUG_TYPE_EXCLUDE = "DrugTypeExclude", E.REFILLS = "Refills", E.DAYS_SUPPLY = "DaysSupply", E.ROUTE_CONCEPT = "RouteConcept", E.ROUTE_CONCEPT_CS = "RouteConceptCS", E.EFFECTIVE_DRUG_DOSE = "EffectiveDrugDose", E.DOSE_UNIT = "DoseUnit", E.DOSE_UNIT_CS = "DoseUnitCS", E.DRUG_SOURCE_CONCEPT = "DrugSourceConcept", E.LOT_NUMBER = "LotNumber", E.MEASUREMENT_TYPE = "MeasurementType", E.MEASUREMENT_TYPE_CS = "MeasurementTypeCS", E.MEASUREMENT_TYPE_EXCLUDE = "MeasurementTypeExclude", E.RACE = "Race", E.ETHNICITY = "Ethnicity", E.OPERATOR = "Operator", E.OPERATOR_CS = "OperatorCS", E.VALUE_AS_NUMBER = "ValueAsNumber", E.VALUE_AS_STRING = "ValueAsString", E.VALUE_AS_CONCEPT = "ValueAsConcept", E.VALUE_AS_CONCEPT_CS = "ValueAsConceptCS", E.ABNORMAL = "Abnormal", E.RANGE_LOW = "RangeLow", E.RANGE_HIGH = "RangeHigh", E.RANGE_LOW_RATIO = "RangeLowRatio", E.RANGE_HIGH_RATIO = "RangeHighRatio", E.MEASUREMENT_SOURCE_CONCEPT = "MeasurementSourceConcept", E.OBSERVATION_TYPE = "ObservationType", E.OBSERVATION_TYPE_CS = "ObservationTypeCS", E.OBSERVATION_TYPE_EXCLUDE = "ObservationTypeExclude", E.QUALIFIER = "Qualifier", E.QUALIFIER_CS = "QualifierCS", E.OBSERVATION_SOURCE_CONCEPT = "ObservationSourceConcept", E.USER_DEFINED_PERIOD = "UserDefinedPeriod", E.PERIOD_START_DATE = "PeriodStartDate", E.PERIOD_END_DATE = "PeriodEndDate", E.PERIOD_TYPE = "PeriodType", E.PERIOD_TYPE_CS = "PeriodTypeCS", E.PERIOD_LENGTH = "PeriodLength", E.PAYER_CONCEPT = "PayerConcept", E.PLAN_CONCEPT = "PlanConcept", E.SPONSOR_CONCEPT = "SponsorConcept", E.STOP_REASON_CONCEPT = "StopReasonConcept", E.PAYER_SOURCE_CONCEPT = "PayerSourceConcept", E.SPONSOR_SOURCE_CONCEPT = "SponsorSourceConcept", E.STOP_REASON_SOURCE_CONCEPT = "StopReasonSourceConcept", E.PLAN_SOURCE_CONCEPT = "PlanSourceConcept", E.PROCEDURE_SOURCE_CONCEPT = "ProcedureSourceConcept", E.PROCEDURE_TYPE = "ProcedureType", E.PROCEDURE_TYPE_CS = "ProcedureTypeCS", E.PROCEDURE_TYPE_EXCLUDE = "ProcedureTypeExclude", E.MODIFIER = "Modifier", E.MODIFIER_CS = "ModifierCS", E.ANATOMIC_SITE = "AnatomicSite", E.ANATOMIC_SITE_CS = "AnatomicSiteCS", E.DISEASE_STATUS = "DiseaseStatus", E.DISEASE_STATUS_CS = "DiseaseStatusCS", E.SOURCE_ID = "SourceId", E.SPECIMEN_TYPE = "SpecimenType", E.SPECIMEN_TYPE_CS = "SpecimenTypeCS", E.SPECIMEN_TYPE_EXCLUDE = "SpecimenTypeExclude", E.GAP_DAYS = "GapDays", E.CODESET_ID = "CodesetId", E.PLACE_SERVICE_LOCATION = "PlaceOfServiceLocation", E.PLACE_SERVICE_DISTANCE = "PlaceOfServiceDistance", E.PLACE_SERVICE = "PlaceOfService", E.VISIT_SOURCE_CONCEPT = "VisitSourceConcept", E.VISIT_LENGTH = "VisitLength", E.VISIT_TYPE_EXCLUDE = "VisitTypeExclude", E.DATE_ADJUSTMENT = "DateAdjustment", E.VISIT_DETAIL_START_DATE = "VisitDetailStartDate", E.VISIT_DETAIL_END_DATE = "VisitDetailEndDate", E.VISIT_DETAIL_TYPE_CS = "VisitDetailTypeCS", E.VISIT_DETAIL_SOURCE_CONCEPT = "VisitDetailSourceConcept", E.VISIT_DETAIL_LENGTH = "VisitDetailLength", E.GENDER_CS = "GenderCS", E.RACE_CS = "RaceCS", E.ETHNICITY_CS = "EthnicityCS", E.PROVIDER_SPECIALTY_CS = "ProviderSpecialtyCS", E.PLACE_SERVICE_CS = "PlaceOfServiceCS", E))(B || {}), h = /* @__PURE__ */ ((E) => (E.ALL = "All", E.FIRST = "First", E.LAST = "Last", E))(h || {}), W = /* @__PURE__ */ ((E) => (E.FIRST_DIAGNOSIS = "FIRST_DIAGNOSIS", E.FIRST_OCCURRENCE = "FIRST_OCCURRENCE", E.AGE_AT_ERA_START = "AGE_AT_ERA_START", E.AGE_AT_ERA_END = "AGE_AT_ERA_END", E.GENDER = "GENDER", E.START_DATE = "START_DATE", E.END_DATE = "END_DATE", E.LOC_START_DATE = "LOC_START_DATE", E.LOC_END_DATE = "LOC_END_DATE", E.ERA_CONDITION_COUNT = "ERA_CONDITION_COUNT", E.ERA_LENGTH = "ERA_LENGTH", E.NESTED = "NESTED", E.AGE_OCCURRENCE = "AGE_OCCURRENCE", E.CONDITION_STATUS = "CONDITION_STATUS", E.CONDITION_STATUS_CS = "CONDITION_STATUS_CS", E.CONDITION_START_DATE = "CONDITION_START_DATE", E.CONDITION_END_DATE = "CONDITION_END_DATE", E.CONDITION_TYPE = "CONDITION_TYPE", E.CONDITION_TYPE_CS = "CONDITION_TYPE_CS", E.STOP_REASON = "STOP_REASON", E.VISIT = "VISIT", E.VISIT_CS = "VISIT_CS", E.CONDITION_SOURCE_CONCEPT = "CONDITION_SOURCE_CONCEPT", E.PROVIDER_SPECIALTY = "PROVIDER_SPECIALTY", E.DEATH_DATE = "DEATH_DATE", E.DEATH_TYPE = "DEATH_TYPE", E.DEATH_TYPE_CS = "DEATH_TYPE_CS", E.CAUSE_DEATH_SOURCE_CONCEPT = "CAUSE_DEATH_SOURCE_CONCEPT", E.FIRST_EXPOSURE = "FIRST_EXPOSURE", E.DEVICE_TYPE = "DEVICE_TYPE", E.DEVICE_TYPE_CS = "DEVICE_TYPE_CS", E.UNIQUE_ID = "UNIQUE_ID", E.QUANTITY = "QUANTITY", E.DEVICE_SOURCE_CONCEPT = "DEVICE_SOURCE_CONCEPT", E.FIRST_MEASURE = "FIRST_MEASURE", E.MEASUREMENT_DATE = "MEASUREMENT_DATE", E.MEASUREMENT_TYPE = "MEASUREMENT_TYPE", E.MEASUREMENT_TYPE_CS = "MEASUREMENT_TYPE_CS", E.OPERATOR = "OPERATOR", E.OPERATOR_CS = "OPERATOR_CS", E.VALUE_AS_CONCEPT = "VALUE_AS_CONCEPT", E.VALUE_AS_CONCEPT_CS = "VALUE_AS_CONCEPT_CS", E.VALUE_AS_NUMBER = "VALUE_AS_NUMBER", E.UNIT = "UNIT", E.UNIT_CS = "UNIT_CS", E.ABNORMAL_RESULT = "ABNORMAL_RESULT", E.LOW_RANGE_RATIO = "LOW_RANGE_RATIO", E.HIGH_RANGE_RATIO = "HIGH_RANGE_RATIO", E.LOW_RANGE = "LOW_RANGE", E.HIGH_RANGE = "HIGH_RANGE", E.MEASUREMENT_SOURCE_CONCEPT = "MEASUREMENT_SOURCE_CONCEPT", E.FIRST_OBSERVATION = "FIRST_OBSERVATION", E.OBSERVATION_DATE = "OBSERVATION_DATE", E.OBSERVATION_TYPE = "OBSERVATION_TYPE", E.OBSERVATION_TYPE_CS = "OBSERVATION_TYPE_CS", E.VALUE_AS_STRING = "VALUE_AS_STRING", E.OBSERVATION_SOURCE_CONCEPT = "OBSERVATION_SOURCE_CONCEPT", E.QUALIFIER = "QUALIFIER", E.QUALIFIER_CS = "QUALIFIER_CS", E.SPECIFY_START_AND_DATE = "SPECIFY_START_AND_DATE", E.FIRST_OBSERVATION_PERIOD = "FIRST_OBSERVATION_PERIOD", E.AGE_AT_START = "AGE_AT_START", E.AGE_AT_END = "AGE_AT_END", E.PERIOD_TYPE = "PERIOD_TYPE", E.PERIOD_TYPE_CS = "PERIOD_TYPE_CS", E.PERIOD_START_DATE = "PERIOD_START_DATE", E.PERIOD_END_DATE = "PERIOD_END_DATE", E.PERIOD_LENGTH = "PERIOD_LENGTH", E.FIRST_PAYER_PLAN_PERIOD = "FIRST_PAYER_PLAN_PERIOD", E.STOP_REASON_SOURCE_CONCEPT = "STOP_REASON_SOURCE_CONCEPT", E.SPONSOR_SOURCE_CONCEPT = "SPONSOR_SOURCE_CONCEPT", E.PLAN_SOURCE_CONCEPT = "PLAN_SOURCE_CONCEPT", E.PAYER_SOURCE_CONCEPT = "PAYER_SOURCE_CONCEPT", E.STOP_REASON_CONCEPT = "STOP_REASON_CONCEPT", E.SPONSOR_CONCEPT = "SPONSOR_CONCEPT", E.PLAN_CONCEPT = "PLAN_CONCEPT", E.PAYER_CONCEPT = "PAYER_CONCEPT", E.FIRST_PROCEDURE = "FIRST_PROCEDURE", E.PROCEDURE_SOURCE_CONCEPT = "PROCEDURE_SOURCE_CONCEPT", E.MODIFIER = "MODIFIER", E.MODIFIER_CS = "MODIFIER_CS", E.PROCEDURE_TYPE = "PROCEDURE_TYPE", E.PROCEDURE_TYPE_CS = "PROCEDURE_TYPE_CS", E.DOSE_VALUE = "DOSE_VALUE", E.ERA_EXPOSURE_COUNT = "ERA_EXPOSURE_COUNT", E.DAYS_SUPPLY = "DAYS_SUPPLY", E.REFILLS = "REFILLS", E.DRUG_TYPE = "DRUG_TYPE", E.DRUG_TYPE_CS = "DRUG_TYPE_CS", E.EFFECTIVE_DOSE = "EFFECTIVE_DOSE", E.ROUTE = "ROUTE", E.ROUTE_CS = "ROUTE_CS", E.RACE = "RACE", E.ETHNICITY = "ETHNICITY", E.DRUG_SOURCE_CONCEPT = "DRUG_SOURCE_CONCEPT", E.LOT_NUMBER = "LOT_NUMBER", E.DOSE_UNIT = "DOSE_UNIT", E.DOSE_UNIT_CS = "DOSE_UNIT_CS", E.SOURCE_ID = "SOURCE_ID", E.DISEASE_STATUS = "DISEASE_STATUS", E.DISEASE_STATUS_CS = "DISEASE_STATUS_CS", E.ANATOMIC_SITE = "ANATOMIC_SITE", E.ANATOMIC_SITE_CS = "ANATOMIC_SITE_CS", E.SPECIMEN_TYPE = "SPECIMEN_TYPE", E.SPECIMEN_TYPE_CS = "SPECIMEN_TYPE_CS", E.SPECIMEN_DATE = "SPECIMEN_DATE", E.GAP_DAYS = "GAP_DAYS", E.FIRST_VISIT = "FIRST_VISIT", E.PLACE_SERVICE_LOCATION = "PLACE_SERVICE_LOCATION", E.PLACE_SERVICE_DISTANCE = "PLACE_SERVICE_DISTANCE", E.PLACE_SERVICE = "PLACE_SERVICE", E.VISIT_SOURCE_CONCEPT = "VISIT_SOURCE_CONCEPT", E.VISIT_LENGTH = "VISIT_LENGTH", E.VISIT_TYPE = "VISIT_TYPE", E.VISIT_TYPE_CS = "VISIT_TYPE_CS", E.FIRST_VISIT_DETAIL = "FIRST_VISIT_DETAIL", E.AGE_AT_VISIT_DETAIL = "AGE_AT_VISIT_DETAIL", E.GENDER_CS = "GENDER_CS", E.RACE_CS = "RACE_CS", E.ETHNICITY_CS = "ETHNICITY_CS", E.VISIT_DETAIL_START_DATE = "VISIT_DETAIL_START_DATE", E.VISIT_DETAIL_END_DATE = "VISIT_DETAIL_END_DATE", E.MODIFY_EVENT_START_END = "MODIFY_EVENT_START_END", E.VISIT_DETAIL_TYPE = "VISIT_DETAIL_TYPE", E.VISIT_DETAIL_LENGTH = "VISIT_DETAIL_LENGTH", E.VISIT_DETAIL_SOURCE_CONCEPT = "VISIT_DETAIL_SOURCE_CONCEPT", E.PROVIDER_SPECIALTY_CS = "PROVIDER_SPECIALTY_CS", E.PLACE_SERVICE_CS = "PLACE_SERVICE_CS", E))(W || {}), F = /* @__PURE__ */ ((E) => (E.BOOL = "bool", E.VALUE = "value", E.DATE = "date", E.VOCABULARY = "vocabulary", E.DROPDOWN = "dropdown", E.GROUP = "group", E.RANGE = "range", E.TEXT = "text", E))(F || {}), g = /* @__PURE__ */ ((E) => (E.STARTING_WITH = "STARTING_WITH", E.CONTAINING = "CONTAINING", E.ENDING_WITH = "ENDING_WITH", E.NOT_STARTING_WITH = "NOT_STARTING_WITH", E.NOT_CONTAINING = "NOT_CONTAINING", E.NOT_ENDING_WITH = "NOT_ENDING_WITH", E))(g || {}), n = /* @__PURE__ */ ((E) => (E.STARTING_WITH = "starting with", E.CONTAINING = "containing", E.ENDING_WITH = "ending with", E.NOT_STARTING_WITH = "not starting with", E.NOT_CONTAINING = "not containing", E.NOT_ENDING_WITH = "not ending with", E))(n || {}), X = /* @__PURE__ */ ((E) => (E.LESS_THAN = "lt", E.LESS_OR_EQUAL_TO = "lte", E.EQUAL_TO = "eq", E.GREATER_THAN = "gt", E.GREATER_OR_EQUAL_TO = "gte", E.BETWEEN = "bt", E.NOT_BETWEEN = "!bt", E))(X || {}), l = /* @__PURE__ */ ((E) => (E.lt = "<", E.lte = "<=", E.eq = "=", E.gt = ">", E.gte = ">=", E.bt = "between", E["!bt"] = "not between", E))(l || {}), f = /* @__PURE__ */ ((E) => (E.lt = "before", E.lte = "on or before", E.eq = "on", E.gt = "after", E.gte = "on or after", E.bt = "between", E["!bt"] = "not between", E))(f || {}), Q = /* @__PURE__ */ ((E) => (E.ALL = "ALL", E.ANY = "ANY", E.AT_LEAST = "AT_LEAST", E.AT_MOST = "AT_MOST", E))(Q || {}), Z = /* @__PURE__ */ ((E) => (E.ALL = "all", E.ANY = "any", E.AT_LEAST = "at least", E.AT_MOST = "at most", E))(Z || {}), K = /* @__PURE__ */ ((E) => (E.END = "END", E.FIXED = "FIXED", E.EXPOSURE = "EXPOSURE", E))(K || {}), J = /* @__PURE__ */ ((E) => (E.STANDARD_CONCEPT = "DOMAIN_CONCEPT", E.START_DATE = "START_DATE", E))(J || {}), z = /* @__PURE__ */ ((E) => (E.END_DATE = "EndDate", E.START_DATE = "StartDate", E))(z || {}), I = /* @__PURE__ */ ((E) => (E.STANDARD = "S", E.CLASSIFICATION = "C", E.NON_STANDARD = "N", E.NON_STANDARD_2 = "NS", E.STANDARD_CAPTION = "Standard", E.NON_STANDARD_CAPTION = "Non-Standard", E.CLASSIFICATION_CAPTION = "Classification", E))(I || {});
const LE = /* @__PURE__ */ new Map([
  [I.STANDARD, { color: "#234589", caption: "Standard" }],
  [
    I.CLASSIFICATION,
    { color: "#e681f3", caption: "Classification" }
  ],
  [
    I.NON_STANDARD,
    { color: "#fb4242", caption: "Non-Standard" }
  ],
  [
    I.NON_STANDARD_2,
    { color: "#fb4242", caption: "Non-Standard" }
  ]
]);
var j = /* @__PURE__ */ ((E) => (E.RELATED = "related", E.DESCENDANTS = "descendants", E.ANCESTORS = "ancestors", E))(j || {}), k = /* @__PURE__ */ ((E) => (E.IDENTIFIERS = "IDENTIFIERS", E.SOURCE_CODES = "SOURCE_CODES", E))(k || {}), q = /* @__PURE__ */ ((E) => (E.INCLUDED_CONCEPTS = "included", E.INCLUDED_SOURCE_CODES = "included-source-code", E))(q || {}), o = /* @__PURE__ */ ((E) => (E.CREATE = "CREATE", E.UPDATE = "UPDATE", E.DELETE = "DELETE", E))(o || {}), $ = /* @__PURE__ */ ((E) => (E.CONTAINER_TO_CONCEPT_SET = "CONTAINER_TO_CONCEPT_SET", E.CONCEPT_SET_TO_CONTAINER = "CONCEPT_SET_TO_CONTAINER", E))($ || {}), x = /* @__PURE__ */ ((E) => (E.NEW = "NEW", E.EXIST = "EXIST", E))(x || {}), r = /* @__PURE__ */ ((E) => (E.TXT = "txt", E.JSON = "json", E.JS = "js", E.R = "r", E.RPROFILE = "rProfile", E.SQL = "sql", E.HTML = "html", E.PACKRAT = "packrat", E.PDF = "pdf", E.DOC = "doc", E.DOCX = "docx", E.XLS = "xls", E.XLSX = "xlsx", E.PPT = "ppt", E.PPTX = "pptx", E.PNG = "png", E.JPG = "jpg", E.JPEG = "jpeg", E.JAR = "jar", E.CSV = "csv", E.ZIP = "zip", E.RAR = "rar", E.GZ = "gz", E.RBUILDIGNORE = "r", E.GITIGNORE = "txt", E.RDATA = "r", E.RPROJ = "r", E.MD = "txt", E.LOCK = "json", E.RD = "r", E.DCF = "txt", E.MP4 = "mp4", E.AVI = "avi", E.MOV = "mov", E.FLV = "flv", E.MP3 = "mp3", E.WAV = "wav", E.WMA = "wma", E.UNKNOWN = "unknown", E))(r || {}), w = /* @__PURE__ */ ((E) => (E.DATE = "MM/DD/YYYY", E.DATE_TIME = "MM/DD/YYYY hh:mm A", E.ISO_DATE = "YYYY-MM-DD", E.ISO_DATE_TIME = "YYYY-MM-DDTHH:mm:ss.SSSSZ", E.DATEPICKER_DATE = "MM/DD/YYYY", E.TIME = "hh:mm A", E))(w || {}), e = /* @__PURE__ */ ((E) => (E.STUDY = "study", E.USER = "user", E.DATA_NODE = "datanode", E.DATASET = "dataset", E.DATASOURCE = "datasource", E.WORKSPACE = "workspace", E.ADMIN = "admin", E.PARTICIPANT = "participant", E.LIBRARY = "library", E.COHORT = "cohort", E.CONCEPT_SET = "concept set", E.LIBRARY_CONCEPT_SET = "library-conceptset", E.LIBRARY_COHORT = "library-cohort", E.LIBRARY_FEATURE_ANALYSIS = "library-feature-analysis", E.SUBMISSION = "submission", E.ANALYSIS = "analysis", E.BUNDLE = "bundle", E.TENANT = "tenant", E.STUDY_TYPE = "study-type", E.CUSTOM_CODE = "custom-code", E.CUSTOMCODE = "customcode", E))(e || {}), T = /* @__PURE__ */ ((E) => (E.COHORT = "COHORT", E.CONCEPT_SET = "CONCEPT_SET", E.FEATURE_ANALYSIS = "FEATURE_ANALYSIS", E.DATA_SOURCE = "DATA_SOURCE", E.METADATA = "METADATA", E.USERS = "USERS", E.ANALYSIS = "ANALYSIS", E.CUSTOM_CODE = "CUSTOM_CODE", E))(T || {}), u = /* @__PURE__ */ ((E) => (E.PUBLIC = "PUBLIC", E.RESTRICTED = "RESTRICTED", E))(u || {}), d = /* @__PURE__ */ ((E) => (E.CDM = "CDM", E.I2B2 = "I2B2", E.CDISK = "CDISK", E.OTHER = "OTHER", E))(d || {}), i = /* @__PURE__ */ ((E) => (E.OPEN_EDIT = "OPEN_EDIT", E.CLOSE_SAVE = "CLOSE_SAVE", E.CLOSE_WITHOUT_SAVE = "CLOSE_WITHOUT_SAVE", E))(i || {}), _ = /* @__PURE__ */ ((E) => (E.IT_PROFESSIONAL = "IT_PROFESSIONAL", E.MEDICAL = "MEDICAL", E.EPIDEMIOLOGY = "EPIDEMIOLOGY", E.DRUG_SAFETY = "DRUG_SAFETY", E.SALES_MARKETING = "SALES_MARKETING", E.FINANCE = "FINANCE", E.ACADEMIC_RESEARCH = "ACADEMIC_RESEARCH", E))(_ || {}), y = /* @__PURE__ */ ((E) => (E.ADMIN_USERS = "admin-users", E.METADATA = "metadata-attributes", E.SYSTEM_SETTINGS = "system-settings", E.TENANTS = "tenants", E.USERS = "users", E.DATA_SOURCES = "data-sources", E.DATA_NODES = "data-nodes", E.ANALYSIS_SETTINGS = "analysis-settings", E))(y || {}), p = /* @__PURE__ */ ((E) => (E.RELATED_CONCEPTS = "related-concepts", E.HIERARCHY = "hierarchy", E.NATIVE_HIERARCHY = "native-hierarchy", E))(p || {}), b = /* @__PURE__ */ ((E) => (E.EXPRESSION = "EXPRESSION", E.INCLUDED_CONCEPTS = "INCLUDED_CONCEPTS", E.INCLUDED_SOURCE_CODES = "INCLUDED_SOURCE_CODES", E))(b || {}), s = /* @__PURE__ */ ((E) => (E.CONCEPT_SET_IN_COHORT = "CONCEPT_SET_IN_COHORT", E.IMPORT_CONCEPT_SET = "IMPORT_CONCEPT_SET", E))(s || {}), t = /* @__PURE__ */ ((E) => (E.DATA_CATALOG = "DATA_CATALOG", E.VIRTUAL_SOURCE = "VIRTUAL_SOURCE", E))(t || {}), EE = /* @__PURE__ */ ((E) => (E.CONCEPT_IDENTIFIERS = "CONCEPT_IDENTIFIERS", E.SOURCE_CODES = "SOURCE_CODES", E))(EE || {}), CE = /* @__PURE__ */ ((E) => (E.FILES_IN_ARCHIVE = "FILES_IN_ARCHIVE", E.SEPARATE_FILES = "SEPARATE_FILES", E))(CE || {}), TE = /* @__PURE__ */ ((E) => (E.LIBRARY = "LIBRARY", E.INCOMING = "INCOMING", E.OUTGOING = "OUTGOING", E))(TE || {}), P = /* @__PURE__ */ ((E) => (E.DIRECT_UPLOAD = "DIRECT_UPLOAD", E.CENTRAL = "CENTRAL", E))(P || {}), _E = /* @__PURE__ */ ((E) => (E[E.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", E))(_E || {}), OE = /* @__PURE__ */ ((E) => (E.WILL_NOT_SCAN = "WILL_NOT_SCAN", E.NOT_SCANNED = "NOT_SCANNED", E.SCANNING = "SCANNING", E.OK = "OK", E.INFECTED = "INFECTED", E))(OE || {}), O = /* @__PURE__ */ ((E) => (E.COHORT = "COHORT", E.CS = "CS", E.CC = "CC", E.PATHWAY = "PATHWAY", E.IR = "IR", E.PLP = "PLP", E.PLE = "PLE", E))(O || {}), SE = /* @__PURE__ */ ((E) => (E.MANUAL = "MANUAL", E.LOCAL = "LOCAL", E.ATLAS = "ATLAS", E))(SE || {}), D = /* @__PURE__ */ ((E) => (E.ADD_NEW_SUBGROUP = "ADD_NEW_SUBGROUP", E.OPEN_CRITERIA = "OPEN_CRITERIA", E.CHOOSE_CRITERIA = "CHOOSE_CRITERIA", E))(D || {}), RE = /* @__PURE__ */ ((E) => (E.EXECUTED = "EXECUTED", E.COMPLETED = "COMPLETED", E.PENDING = "PENDING", E.SEND = "SEND", E.FAILED = "FAILED", E.INITIALIZE = "INITIALIZE", E.EXECUTE = "EXECUTE", E.ABORT = "ABORT", E.ABORTED = "ABORTED", E.ABORT_FAILURE = "ABORT_FAILURE", E))(RE || {}), NE = /* @__PURE__ */ ((E) => (E.ANALYSIS = "analysis", E.CONCEPT_SET = "conceptSets", E.COHORT = "cohort", E.ANALYSIS_SUBMISSION = "analysisSubmission", E.CUSTOM_CODE = "folder", E))(NE || {}), IE = /* @__PURE__ */ ((E) => (E.FILE_EXPLORER = "FILE_EXPLORER", E.LOG = "LOG", E))(IE || {}), AE = /* @__PURE__ */ ((E) => (E.ERA = "ERA", E))(AE || {}), PE = /* @__PURE__ */ ((E) => (E.PrimaryCriteria = "PrimaryCriteria", E.QualifiedLimit = "QualifiedLimit", E.ExpressionLimit = "ExpressionLimit", E.InclusionRules = "InclusionRules", E.CensoringCriteria = "CensoringCriteria", E.CollapseSettings = "CollapseSettings", E.CensorWindow = "CensorWindow", E.ConceptSets = "ConceptSets", E))(PE || {}), DE = /* @__PURE__ */ ((E) => (E.STUDY = "study", E.USER = "user", E.DATA_NODE = "datanode", E.DATASET = "dataset", E.DATASOURCE = "datasource", E.WORKSPACE = "workspace", E.ADMIN = "admin", E.PARTICIPANT = "participant", E.LIBRARY = "library", E.COHORT = "cohort", E.CONCEPT_SET = "concept set", E.LIBRARY_CONCEPT_SET = "library conceptset", E.LIBRARY_COHORT = "library cohort", E.SUBMISSION = "submission", E.ANALYSIS = "analysis", E.BUNDLE = "bundle", E.TENANT = "tenant", E.STUDY_TYPE = "study type", E.CUSTOM_CODE = "custom code", E.CUSTOMCODE = "custom code", E))(DE || {}), UE = /* @__PURE__ */ ((E) => (E.CREATE_NEW_OBJECT = "NEW_OBJECT", E.CREATE_NEW_VERSION = "NEW_VERSION", E.COPY = "COPY", E))(UE || {});
const cE = [
  {
    id: S.INITIATE,
    shortcut: 1,
    name: "Initiate"
  },
  {
    id: S.ACTIVE,
    shortcut: 2,
    name: "Active"
  },
  {
    id: S.COMPLETED,
    shortcut: 3,
    name: "Completed"
  },
  {
    id: S.ARCHIVED,
    shortcut: 4,
    name: "Archived"
  }
], YE = [
  {
    value: C.COHORT,
    name: "Cohort Counts"
  },
  {
    value: C.INCIDENCE,
    name: "Incidence Rates"
  },
  {
    value: C.COHORT_CHARACTERIZATION,
    name: "Cohort Characterization"
  },
  {
    value: C.SIMPLE_COUNTS_CHARACTERIZATION,
    name: "Cohort Counts with Demographics"
  },
  {
    value: C.COHORT_PATHWAY,
    name: "Cohort Pathway"
  },
  {
    value: C.CUSTOM,
    name: "Custom"
  },
  {
    value: C.ESTIMATION,
    name: "Population Level Estimation"
  },
  {
    value: C.STRATEGUS,
    name: "Strategus"
  },
  { value: C.DATACUT, name: "Cohort Export" },
  {
    value: C.BULK_COHORT_COUNTS,
    name: "Cohort Counts with Demographics (Multi)"
  }
], aE = {
  [C.COHORT]: "Cohort Counts",
  [C.INCIDENCE]: "Incidence Rates",
  [C.COHORT_CHARACTERIZATION]: "Cohort Characterization",
  [C.COHORT_PATHWAY]: "Cohort Pathway",
  [C.ESTIMATION]: "Population Level Estimation",
  [C.CUSTOM]: "Custom",
  [C.STRATEGUS]: "Strategus",
  [C.SIMPLE_COUNTS_CHARACTERIZATION]: "Cohort Counts with Demographics",
  [C.DATACUT]: "Cohort Export",
  [C.BULK_COHORT_COUNTS]: "Cohort Counts with Demographics (Multi)",
  [C.FEASIBILITY]: "Feasibility",
  [C.TIME_TO_EVENT]: "Time to Event",
  [C.COST]: "Cost Utilization"
}, GE = [
  {
    name: "Number",
    value: N.INTEGER
  },
  {
    name: "Text",
    value: N.STRING
  },
  {
    name: "List of values",
    value: N.ENUM
  },
  {
    name: "Multiple values",
    value: N.ENUM_MULTI
  }
], ME = [
  {
    name: "IT professional",
    value: _.IT_PROFESSIONAL
  },
  {
    name: "Medical",
    value: _.MEDICAL
  },
  {
    name: "Epidemiology",
    value: _.EPIDEMIOLOGY
  },
  {
    name: "Drug safety",
    value: _.DRUG_SAFETY
  },
  {
    name: "Sales & marketing",
    value: _.SALES_MARKETING
  },
  {
    name: "Finance",
    value: _.FINANCE
  },
  {
    name: "Academic research",
    value: _.ACADEMIC_RESEARCH
  }
], HE = [
  {
    value: P.CENTRAL,
    name: "Central"
  },
  {
    value: P.DIRECT_UPLOAD,
    name: "Data node"
  }
], VE = [
  {
    value: T.COHORT,
    name: "Cohort"
  },
  {
    value: T.CONCEPT_SET,
    name: "Concept set"
  },
  {
    value: T.FEATURE_ANALYSIS,
    name: "Feature analysis"
  },
  {
    value: T.DATA_SOURCE,
    name: "Data source"
  },
  {
    value: T.CUSTOM_CODE,
    name: "Custom code"
  }
], mE = {
  [T.COHORT]: {
    name: "Cohort",
    iconName: "cohort",
    type: T.COHORT,
    color: "purple.main"
  },
  [T.CONCEPT_SET]: {
    name: "Concept set",
    iconName: "conceptSets",
    type: T.CONCEPT_SET,
    color: "teal.main"
  },
  [T.FEATURE_ANALYSIS]: {
    name: "Feature analysis",
    iconName: "analysis",
    color: "info.main",
    type: T.FEATURE_ANALYSIS
  },
  [T.CUSTOM_CODE]: {
    name: "Custom code",
    iconName: "folder",
    color: "green.main",
    type: T.CUSTOM_CODE
  }
}, vE = [
  {
    value: R.ACCEPTED,
    name: "Accepted"
  },
  {
    value: R.CANCELLED,
    name: "Cancelled"
  },
  {
    value: R.REJECTED,
    name: "Rejected"
  },
  {
    value: R.PENDING,
    name: "Pending"
  }
], BE = [
  {
    value: A.WORKSPACE,
    name: "Workspace"
  },
  {
    value: A.STUDY,
    name: "Study"
  },
  {
    value: "ATLAS",
    name: "Atlas"
  }
], hE = [
  {
    value: O.COHORT,
    name: "Cohort",
    type: C.COHORT
  },
  {
    value: O.CS,
    name: "Concept set"
  },
  {
    value: O.CC,
    name: "Cohort Characterization",
    type: C.COHORT_CHARACTERIZATION
  },
  {
    value: O.PATHWAY,
    name: "Cohort Pathway",
    type: C.COHORT_PATHWAY
  },
  {
    value: O.IR,
    name: "Incidence Rates",
    type: C.INCIDENCE
  },
  {
    value: O.PLE,
    name: "Population Level Estimation",
    type: C.ESTIMATION
  },
  {
    value: O.PLP,
    name: "Prediction",
    type: C.PREDICTION
  }
], WE = {
  DEFAULT: {
    icon: "analysis",
    color: "#0d1b40",
    name: "Analysis"
  },
  [C.COHORT]: {
    icon: "analysisSimpleCount",
    color: "#33c480",
    name: "Cohort Counts"
  },
  [C.INCIDENCE]: {
    icon: "analysisIncidence",
    color: "#49d1ff",
    name: "Incidence Rates"
  },
  [C.COHORT_PATHWAY]: {
    icon: "analysisPathway",
    color: "#b777ff",
    name: "Cohort Pathway"
  },
  [C.COHORT_CHARACTERIZATION]: {
    icon: "analysisCharacterization",
    color: "#ff7171",
    name: "Cohort Characterization"
  },
  [C.SIMPLE_COUNTS_CHARACTERIZATION]: {
    icon: "analysisCountsWithDemographics",
    color: "#ff7171",
    name: "Cohort Counts with Demographics"
  },
  [C.CUSTOM]: {
    icon: "analysisCustom",
    color: "#f5b502",
    name: "Custom"
  },
  [C.STRATEGUS]: {
    icon: "analysisStrategus",
    color: "#f5b502",
    name: "Strategus"
  },
  [C.ESTIMATION]: {
    icon: "analysisPopulationLevelEstimation",
    color: "#79ba38",
    name: "Population Level Estimation"
  },
  [C.PREDICTION]: {
    icon: "analysis",
    color: "#d69d00",
    name: "Prediction"
  },
  [C.DATACUT]: {
    icon: "analysisDataCut",
    color: "#38ba91",
    name: "Cohort Export"
  },
  [C.BULK_COHORT_COUNTS]: {
    icon: "analysisCountsWithDemographicsMulti",
    color: "#2bc977",
    name: "Cohort Counts with Demographics (Multi)"
  },
  [C.FEASIBILITY]: {
    icon: "analysisFeasibility",
    color: "#0d1b40",
    name: "Feasibility"
  },
  [C.TIME_TO_EVENT]: {
    icon: "analysisTimeToEvent",
    color: "#f557d8ff",
    name: "Time to Event"
  },
  [C.COST]: {
    icon: "analysisCost",
    color: "#f557d8ff",
    name: "Cost Utilization"
  }
}, FE = [
  {
    id: "DEFAULT",
    name: "Create Analysis",
    desc: "",
    endGroup: !0
  },
  {
    id: C.COHORT,
    name: "Use in Cohort Counts",
    desc: ""
  },
  {
    id: C.SIMPLE_COUNTS_CHARACTERIZATION,
    name: "Use in Cohort Counts with Demographics",
    desc: ""
  },
  {
    id: C.COHORT_PATHWAY,
    name: "Use in Cohort Pathway",
    desc: ""
  },
  {
    id: C.INCIDENCE,
    name: "Use in Incidence Rates",
    desc: ""
  },
  {
    id: C.COHORT_CHARACTERIZATION,
    name: "Use in Cohort Characterization",
    desc: ""
  },
  {
    id: C.BULK_COHORT_COUNTS,
    name: "Use in Cohort Counts with Demographics (Multi)",
    desc: ""
  },
  {
    id: C.FEASIBILITY,
    name: "Use in Feasibility",
    desc: ""
  },
  {
    id: C.COST,
    name: "Use in Cost Utilization",
    desc: ""
  },
  {
    id: C.TIME_TO_EVENT,
    name: "Use in Time to Event",
    desc: ""
  },
  {
    id: C.CUSTOM,
    name: "Use in Custom Analysis",
    desc: ""
  },
  {
    id: C.DATACUT,
    name: "Use in Cohort Export",
    desc: ""
  }
], gE = [
  {
    id: D.ADD_NEW_SUBGROUP,
    name: "Add new criteria",
    desc: "",
    endGroup: !0
  },
  // {
  //   id: TypesOfCreationBlock.OPEN_CRITERIA,
  //   name: 'Open criteria constructor',
  //   desc: '',
  // },
  {
    id: D.CHOOSE_CRITERIA,
    name: "Choose criteria from library",
    desc: ""
  }
];
export {
  y as AdminTabs,
  c as AnalysisSubmissionStatus,
  C as AnalysisTypes,
  OE as AntivirusFileStatus,
  m as AppBuildMode,
  F as AttributeDetailsTypes,
  B as AttributeTypes,
  AE as CollapseType,
  b as ConceptSetSectionTabs,
  Q as CountEvents,
  Z as CountEventsChar,
  CE as CreateSubmissionFormTabs,
  v as CriteriaTypes,
  M as DataCatalogMetaAttributeType,
  u as DataSourceAccessType,
  H as DataSourceExecutionPolicy,
  t as DataSourceFormTabs,
  d as DataSourceModelTypes,
  V as DataSourceReportVariant,
  z as DateEdge,
  w as DateFormat,
  PE as DefinitionKeys,
  $ as DirectionFormatConceptSet,
  W as DropdownAttributesIds,
  mE as ENTITY_TYPES,
  i as EditLocator,
  NE as EntityIconNames,
  e as EntityType,
  DE as EntityTypeLabel,
  T as EntityTypes,
  _E as ErrorStatuses,
  K as EventPersistence,
  r as FileExtension,
  L as HealthStatus,
  O as ImportAtlasAsset,
  s as ImportConceptSetTabs,
  EE as ImportConceptsTabs,
  g as IntervalInclude,
  n as IntervalIncludeChar,
  X as IntervalValue,
  l as IntervalValueChars,
  f as IntervalValueDateChars,
  R as InvitationStatus,
  TE as LibraryTabs,
  h as LimitEvents,
  o as LoggingConcepts,
  U as MediaType,
  N as MetaAttributeTypes,
  UE as NameConflictResolution,
  J as OccurrenceCriteria,
  P as OriginSubmission,
  SE as OtherImportTypes,
  _ as ProfessionalType,
  I as StandardConceptTypes,
  Y as StudyParticipantRole,
  S as StudyStatuses,
  IE as SubmissionResultTabs,
  RE as SubmissionStatus,
  k as TypeOfImportConcepts,
  A as TypesOfContainer,
  D as TypesOfCreationBlock,
  q as TypesOfIncluded,
  j as TypesOfRelatedConcepts,
  x as TypesOfSave,
  G as ValidationMessageSeverity,
  a as ValidationMessageType,
  p as VocabularyConceptTabs,
  FE as analysisBaseInfoActions,
  YE as analysisTypes,
  aE as analysisTypesMap,
  hE as atlasAssetList,
  BE as containerTypes,
  VE as entityTypes,
  WE as iconAnalyses,
  vE as invitationTypes,
  LE as mapStandardConceptTypes,
  GE as metaAttributesTypes,
  HE as originSubmissions,
  ME as professionalTypes,
  cE as studyStatuses,
  gE as typesOfCreationBlock
};
//# sourceMappingURL=enums.js.map
